module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"remove":"Remove"},"fr":{"remove":"Supprimer"}}')
  delete Component.options._Ctor
}
